// extracted by mini-css-extract-plugin
export default {"bgContainer":"firstStep_bgContainer__o8O80","mainContainerBg":"firstStep_mainContainerBg__1y-v8","QrContainer":"firstStep_QrContainer__yzHIU"};